const UserProfile = () => {

    return (
        <div>Coming soon</div>
    );
};

export default UserProfile